/* @flow */

import { getBraindateId } from '@braindate/domain/lib/braindate/util';

import * as types from 'src/shared/app/check-in/action/uiCheckInActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

/*
 |------------------------------------------------------------------------------
 | Initial state
 |------------------------------------------------------------------------------
 */

const initialState = {
  isAnimationRunning: {},
  isFetching: {},
};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const markAnimationAsRunning = (state: Object, { braindate }: Object) => ({
  ...state,
  isAnimationRunning: {
    ...state.isAnimationRunning,
    [getBraindateId(braindate)]: true,
  },
});

const markAnimationAsDone = (state: Object, { braindate }: Object) => ({
  ...state,
  isAnimationRunning: {
    ...state.isAnimationRunning,
    [getBraindateId(braindate)]: false,
  },
});

const markCheckinFetching = (state: Object, { braindate }: Object) => ({
  ...state,
  isFetching: {
    ...state.isFetching,
    [getBraindateId(braindate)]: true,
  },
});
const markCheckinSuccess = (state: Object, { braindate }: Object) => ({
  ...state,
  isFetching: {
    ...state.isFetching,
    [getBraindateId(braindate)]: false,
  },
});

export default createReducer(initialState, {
  [types.MARK_CHECK_IN_ANIMATION_AS_RUNNING]: markAnimationAsRunning,
  [types.MARK_CHECK_IN_ANIMATION_AS_DONE]: markAnimationAsDone,
  [types.MARK_CHECKIN_FETCHING]: markCheckinFetching,
  [types.MARK_CHECKIN_SUCCESS]: markCheckinSuccess,
});
